export default __webpack_public_path__ + "static/media/light-arrow_left_disabled_dark.2f8fb46a.svg";